import { gql } from "@apollo/client";export default gql`mutation DeleteGroupTabMap($tab_id: Int, $group_id: Int) {
    deleteGroupTabMap: delete_home_explore_group_tab_map(
        where: { tab_id: { _eq: $tab_id }, group_id: { _eq: $group_id } }
    ) {
        affected_rows
    }
}
`;
